import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { news } from "../mock";

// Sekcia Aktuality na domovskej stránke – zobrazí najnovšie 3 príspevky.
const News = () => {
  const latest = news.slice(0, 3);
  return (
    <section id="aktuality" className="bg-campaign-cream px-4 sm:px-6 py-16 sm:py-24 border-t-4 border-campaign-ink">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <h2 className="font-display text-4xl sm:text-6xl text-campaign-ink leading-none uppercase">
            Aktuality z kampane
          </h2>
          <Link
            to="/aktuality"
            className="inline-flex items-center gap-2 font-display uppercase text-sm text-campaign-blue hover:underline"
          >
            Všetky aktuality <ArrowRight size={18} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((post) => (
            <article key={post.slug} className="bg-campaign-cream border-4 border-campaign-ink shadow-brutal hover-lift flex flex-col">
              <Link to={`/aktuality/${post.slug}`} className="block">
                <img
                  src={post.image}
                  alt={post.title}
                  loading="lazy"
                  className="w-full h-48 object-cover border-b-4 border-campaign-ink"
                />
              </Link>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-flex items-center gap-1.5 text-campaign-ink/60 text-xs font-bold uppercase mb-2">
                  <CalendarDays size={14} /> {post.dateLabel}
                </span>
                <h3 className="font-display text-lg text-campaign-ink uppercase leading-tight mb-2">
                  <Link to={`/aktuality/${post.slug}`} className="hover:text-campaign-blue">{post.title}</Link>
                </h3>
                <p className="text-campaign-ink/80 text-sm flex-1">{post.excerpt}</p>
                <Link to={`/aktuality/${post.slug}`} className="mt-4 inline-flex items-center gap-1 font-semibold text-campaign-blue hover:underline">
                  Čítať viac <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
